export default __webpack_public_path__ + "static/media/Mohammed-Ramdani.294d925f.png";